import React from 'react'
import moment from 'moment'
import { Text, View } from '@react-pdf/renderer'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import { DEBRIEF_FIELDS } from '../../ePCR/liveCapture/catalogue'
import { getCategory, getMergedTimeline } from '../../ePCR/liveCapture/engine'
import {
  describeLiveEvent,
  fmtOffset,
  fmtTime,
  hasLiveEvents,
  liveStartOf,
  pdfSafe,
} from '../../ePCR/liveCapture/liveUi'

const cell = { paddingVertical: 2, paddingHorizontal: 4 }

// Live console timeline (arrest + critical care) as a table, plus
// categories and the hot debrief.
const LiveTimeline = ({ epcr }) => {
  const categories = epcr?.criticalCare?.categories ?? []
  const debrief = epcr?.criticalCare?.debrief
  if (!hasLiveEvents(epcr) && !categories.length && !debrief) return null

  const timeline = getMergedTimeline(epcr)
  const start = liveStartOf(epcr)
  const weight = epcr?.criticalCare?.weightKg

  return (
    <RecordSection title="Live Timeline">
      <View style={{ fontSize: 10, paddingHorizontal: 5, paddingVertical: 4 }}>
        {categories.length > 0 && (
          <InfoLine
            label="Categories"
            value={pdfSafe(
              categories
                .map((key) => getCategory(key)?.label ?? key)
                .join(', '),
            )}
          />
        )}
        {weight ? (
          <InfoLine
            label="Weight"
            value={`${weight}kg${
              epcr.criticalCare.weightSource
                ? ` (${epcr.criticalCare.weightSource})`
                : ''
            }`}
          />
        ) : null}
        {epcr?.cardiacArrest?.startedAt && (
          <InfoLine
            label="Arrest console started"
            value={moment(epcr.cardiacArrest.startedAt).format(
              'DD/MM/YYYY HH:mm:ss',
            )}
          />
        )}
        {timeline.length > 0 && (
          <View style={{ marginTop: 4 }}>
            <View
              style={{
                flexDirection: 'row',
                fontFamily: 'Helvetica-Bold',
                borderBottomWidth: 1,
                borderColor: '#616161',
              }}
              fixed
            >
              <Text style={{ ...cell, width: 60 }}>Time</Text>
              <Text style={{ ...cell, width: 55 }}>Elapsed</Text>
              <Text style={{ ...cell, flex: 1 }}>Event</Text>
            </View>
            {timeline.map((event, index) => (
              <View
                key={event.id || `${event.type}-${event.time}`}
                style={{
                  flexDirection: 'row',
                  backgroundColor: index % 2 ? '#F5F5F5' : '#FFFFFF',
                }}
                wrap={false}
              >
                <Text style={{ ...cell, width: 60 }}>
                  {fmtTime(event.time)}
                </Text>
                <Text style={{ ...cell, width: 55 }}>
                  {fmtOffset(event.time, start)}
                </Text>
                <Text style={{ ...cell, flex: 1 }}>
                  {pdfSafe(describeLiveEvent(event))}
                </Text>
              </View>
            ))}
          </View>
        )}
        {debrief && (
          <View style={{ marginTop: 8 }}>
            <Text
              style={{ fontFamily: 'Helvetica-Bold', paddingHorizontal: 5 }}
            >
              Hot debrief
              {debrief.completedAt
                ? ` (${moment(debrief.completedAt).format('DD/MM/YYYY HH:mm')})`
                : ''}
            </Text>
            {DEBRIEF_FIELDS.filter((field) => debrief[field.key]).map(
              (field) => (
                <InfoLine
                  key={field.key}
                  label={pdfSafe(field.label)}
                  value={pdfSafe(String(debrief[field.key]))}
                />
              ),
            )}
          </View>
        )}
      </View>
    </RecordSection>
  )
}

export default LiveTimeline
